import Chart from 'chart.js';

const chartContainer = document.querySelector('.fund-graph');

if (chartContainer) {
    const chartEl = document.getElementById('heimdal-chart');
    const customSelect = document.querySelector('.custom-select');
    const $chartWrapper = $('.chart .chart-wrapper');
    const $loadingSpinner = $('.chart .loading-spinner');
    const $noDataMessage = $('.chart .no-data');
    const $fromDate = $('#graph-from-date');
    const $toDate = $('#graph-to-date');
    const $totalReturn = $('.return');
    const $presetButtons = $('.period-presets button');
    // The inputs are rendered with the first and last date we have prices for,
    // so they double as the bounds the period presets can move within.
    const minDate = $fromDate.val();
    const maxDate = $toDate.val();
    let chart = null;
    let isFirstLoad = true;

    if (customSelect) {
        // Filtering functionality
        customSelect.addEventListener('change', function (e) {
            const filterValue = e.detail.value;
            const fundName = e.detail.fundName;
            const andelsklasse = e.detail.andelsklasse;

            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("andelsklasse", andelsklasse);
            window.location.search = searchParams.toString();
        });
    }

    if (chartEl) {
        const instrumentCode = chartEl.getAttribute('data-instrument-code');
        const dateFormatter = new Intl.DateTimeFormat('nb-NO', {dateStyle: 'short'});
        const numberFormatter = new Intl.NumberFormat('nb-NO', {maximumFractionDigits: 2});

        const config = {
            type: "line",
            data: {
                labels: [],
                datasets: []
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            type: 'time',
                            ticks: {
                                maxTicksLimit: 7,
                                maxRotation: 0,
                            }
                        }
                    ]
                },
                legend: {
                    display: false
                },
                elements: {
                    point: {
                        radius: 0,
                        borderWidth: 0,
                    }
                },
                tooltips: {
                    callbacks: {
                        title: function(tooltipItem, data) {
                            return dateFormatter.format(new Date(tooltipItem[0].xLabel));
                        },
                        label: function(tooltipItem, data) {
                            return numberFormatter.format(tooltipItem.yLabel);
                        }
                    }
                },
            }
        };
        Chart.defaults.global.defaultFontFamily = 'Suisse';
        chart = new Chart('heimdal-chart', config);

        if (instrumentCode) {
            loadGraphData(instrumentCode);

            $('#graph-show').click(function () {
                clearActivePreset();
                loadGraphData(instrumentCode, $fromDate.val(), $toDate.val());
            })

            $fromDate.add($toDate).on('change input', clearActivePreset);

            $presetButtons.each(function () {
                const $button = $(this);
                const fromDate = getPeriodStart($button.data('period'));

                // A fund that is younger than the period has no data to show for it.
                if (!fromDate || fromDate < minDate) {
                    $button.prop('disabled', true);
                    return;
                }

                $button.click(function () {
                    $fromDate.val(fromDate);
                    $toDate.val(maxDate);

                    $presetButtons.removeClass('active').attr('aria-pressed', 'false');
                    $button.addClass('active').attr('aria-pressed', 'true');

                    loadGraphData(instrumentCode, fromDate, maxDate);
                });
            });
        }
    }

    function clearActivePreset() {
        $presetButtons.removeClass('active').attr('aria-pressed', 'false');
    }

    /**
     * Start date for a preset period, counted back from the last date we have prices for.
     * The month and year to date periods start on the previous period's closing price,
     * which is what the returns in the fund overview table are measured against.
     */
    function getPeriodStart(period) {
        if (!minDate || !maxDate) {
            return null;
        }

        const end = parseDate(maxDate);

        switch (period) {
            case 'mtd':
                return formatDate(lastWeekday(new Date(end.getFullYear(), end.getMonth(), 0)));
            case 'ytd':
                return formatDate(lastWeekday(new Date(end.getFullYear(), 0, 0)));
            case '3m':
                return formatDate(subtractMonths(end, 3));
            case '12m':
                return formatDate(subtractMonths(end, 12));
            case '3y':
                return formatDate(subtractMonths(end, 36));
            case '5y':
                return formatDate(subtractMonths(end, 60));
            case 'start':
                return minDate;
            default:
                return null;
        }
    }

    function parseDate(value) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    function formatDate(date) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${date.getFullYear()}-${month}-${day}`;
    }

    /**
     * Steps back to the Friday when the date lands on a weekend, so the period starts
     * on a day the fund is likely to have a price for.
     */
    function lastWeekday(date) {
        const result = new Date(date.getTime());
        while (result.getDay() === 0 || result.getDay() === 6) {
            result.setDate(result.getDate() - 1);
        }
        return result;
    }

    function subtractMonths(date, months) {
        const day = date.getDate();
        const result = new Date(date.getFullYear(), date.getMonth(), 1);
        result.setMonth(result.getMonth() - months);

        // Clamp to the last day of the target month, so 31 March minus one month is 28 February.
        const daysInMonth = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();
        result.setDate(Math.min(day, daysInMonth));
        return result;
    }

    function loadGraphData(instrumentCode, fromDate = null, toDate = null) {
        let data = new FormData();
        data.append('action', 'get_chart_data');
        data.append('instrumentCode', instrumentCode);

        if (fromDate) {
            data.append('fromDate', fromDate);
        }
        if (toDate) {
            data.append('toDate', toDate);
        }

        $.ajax({
            url: heimdal_scripts.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            processData: false,
            contentType: false,
            dataType: "json",
            error: function (data) {
                console.error(data);
            },
            complete: function (data) {
                const json = data.responseJSON;
                if (json && json['datasets']) {
                    const datasets = json['datasets'] || [];

                    // The number of datasets varies with the selected period (the series is
                    // split on gaps longer than 10 days). Without this reset, datasets from
                    // the previous view are left behind and the graph shows the full history.
                    chart.data.datasets.length = 0;

                    for (const key in datasets) {
                        chart.data.datasets[key] = {
                            data: datasets[key],
                            borderColor: '#CDAD80',
                            backgroundColor: '#CDAD80',
                            fill: false,
                            showLine: true,
                            spanGaps: true,
                        };
                    }

                    chart.update();

                    if (isFirstLoad && json['datasets'].length > 0) {
                        const firstDataSet = json['datasets'][0];
                        const lastDataSet = json['datasets'][json['datasets'].length - 1];
                        if (firstDataSet && firstDataSet.length > 0) {
                            $fromDate.val(firstDataSet[0]['x']);
                        }
                        if (lastDataSet && lastDataSet.length > 0) {
                            $toDate.val(lastDataSet[lastDataSet.length - 1]['x']);
                        }
                    }

                    const numberFormatter = new Intl.NumberFormat("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
                    const hasData = json['datasets'].length > 0 && json['datasets'][0].length > 0;
                    if (hasData && json['return'] !== null && json['return'] !== undefined) {
                        $totalReturn.html(numberFormatter.format(parseFloat(json['return']) * 100) + '%');
                    } else {
                        $totalReturn.html('');
                    }

                    $loadingSpinner.hide();
                    if (json['datasets'].length > 0 && json['datasets'][0].length > 0) {
                        $chartWrapper.show();
                        $noDataMessage.hide();
                    } else {
                        $chartWrapper.hide();
                        $noDataMessage.show();
                    }
                    isFirstLoad = false;
                }
            }
        });
    }
}
